; (function ($, _) {
    var common = require('../common');
    var api = require('./xl_api');
    var pagination = require('./pagination');
    var DoubanComments = require('./douban_comments');
    var dialog = require('../ui/dialog');

    var defaultText = ' 我来说两句... ';
    var opts = {
        $container: null,
        $textarea: null,
        $comBtn: null,
        template: '',
        request: '',
        movieid: '',
        length: 10,
        comCallback: $.noop
    };

    /**
     * 视频评论
     * @class VideoCom
     * @constructor
     */
    var VideoComments = {
        dataSource: {
            data: [],
            count: 0
        },
        doubanid: '',
        /**
         * 模块初始化
         * @method init
         */
        init: function (options) {
            opts = _.extend(opts, options);
            this.initUI();
            this.eventBinding();
        },

        /**
         * 界面初始化
         * @method initUI
         */
        initUI: function () {
            this.doubanid = $('[data-doubanid]').data('doubanid');
            this.render();
            dialog.init({
                ensureText: '关闭',
                icon: 'ico_p_warn'
            });
        },

        /**
         * 事件绑定
         * @method eventBinding
         */
        eventBinding: function () {
            var $area = opts.$textarea;
            $area.on('focus', function () {
                var val = $area.val();
                if (val == defaultText) {
                    $area.val('');
                }
            }).on('blur', function () {
                var val = $area.val();
                if (val == null || val == '') {
                    $area.val(defaultText);
                }
            });

            opts.$comBtn.on('click', function () {
                common.login_from_comments = true;
                VideoComments.commentsHandler();
                return false;
            });

            $area.on('keyup', function () {
                var content = $area.val();
                var max = 300;
                if (content == '' || content == null || content == defaultText) {
                    opts.$comBtn
                        .addClass('dis');
                } else {
                    opts.$comBtn.filter('.dis')
                        .removeClass('dis');
                }
                if (content.length > max) {
                    content = content.substr(0, max);
                    $area.val(content);
                }
            });

            common.events.on('FINISH_JUMP', function () {
                if (common.login_from_comments) {
                    VideoComments.commentsHandler();
                }

                if (common.login_from_praise) {
                    VideoComments.praiseHandler($('[data-role="praise"]'), common.getParameter('movieid'));
                }
            });
        },

        /**
         * 评论页渲染
         * @method commentsRender
         */
        render: function () {
            this.getComments(0, function (json) {
                var total = json.count;
                var $comments = $('[data-role="comments"]');
                $comments.html('<span class="ico_comment"></span> ' + total + '条评论')
                    .attr('count', total);

                if (total == 0) {
                    $('.com_list_null').show();
                    $('.com_list_des').hide();
                } else {
                    $('.com_list_null').remove();
                    $('.com_list_des').show();
                    pagination.init({
                        length: opts.length,
                        total: total
                    });
                    pagination.setPageRender(VideoComments.getComments);
                }
            });
        },

        /**
         * 获得评论内容
         * @method getComments
         */
        getComments: function (offset, callback) {
            var $uls = opts.$container.find('ul');
            var self = VideoComments;
            if ($uls.filter('[offset="' + offset + '"]').length == 0) {
                VideoComments.fetchDoubanComments(offset)
                    .then(function () {
                        return self.fetchComments(offset);
                    })
                    .always(function (json) {
                        var data = {
                            offset: offset,
                            count: self.dataSource.count
                        };
                        if (json.errno === 0) {
                            self.dataSource.data = self.dataSource.data.concat(json.data);
                            data.count = self.dataSource.count + json.count;
                        };
                        data.data = self.dataSource.data.splice(0, 5);

                        $uls.filter('[data-offset!="' + offset + '"]').hide();
                        opts.$container.append(opts.template(data));
                        typeof callback == 'function' && callback(data);
                    });

            } else {
                $uls.filter('[offset!="' + offset + '"]').hide();
                $uls.filter('[offset="' + offset + '"]').show();
                typeof callback == 'function' && callback();
            }
        },

        fetchDoubanComments: function (offset) {
            var deferred = $.Deferred();
            var self = VideoComments;
            if (offset === 0 && VideoComments.doubanid) {
                DoubanComments(VideoComments.doubanid)
                    .then(function (json) {
                        self.dataSource.data = json.data || [];
                        self.dataSource.count = json.data ? json.data.length : 0;
                        deferred.resolve();
                    })
                    .fail(function () {
                        deferred.resolve();
                    });
            } else {
                deferred.resolve();
            }
            return deferred;

        },
        fetchComments: function (offset) {
            return $.ajax({
                url: opts.request,
                dataType: 'jsonp',
                data: {
                    movieid: opts.movieid,
                    offset: offset,
                    length: opts.length
                }
            });
        },

        commentsHandler: function () {
            var $comBtn = opts.$comBtn;
            var $area = opts.$textarea;
            var content = $area.val();
            // alert(
            //     "common.getXl9Data('is_loging') == 1 " + (common.getXl9Data('is_loging') == 1) + "\n" + 
            //     "!common.clientLogined()" + (!common.clientLogined()) + '\n' +
            //     "common.webLoginStatusMissing()" + (common.webLoginStatusMissing()) + '\n' +
            //     "$comBtn.hasClass('dis')" + ($comBtn.hasClass('dis'))  + '\n' +
            //     "content == '' || content == null || content == defaultText"  + (content == '' || content == null || content == defaultText) + '\n' +
            //     "$comBtn.attr('disable') == 'disable'" + ($comBtn.attr('disable') == 'disable') 
            // );
            if (common.getXl9Data('is_loging') == 1) {
                return false;
            }

            if (!common.clientLogined()) {
                api.showLoginDlg('moviedetail_comment');
                return false;
            }

            if (common.webLoginStatusMissing()) {
                common.events.trigger('userLogin');
                return false;
            }

            if ($comBtn.hasClass('dis')) {
                return false;
            }

            if (content == '' || content == null || content == defaultText) {
                return false;
            }

            if ($comBtn.attr('disable') == 'disable') {
                return false;
            }

            $comBtn.attr('disable', 'disable');
            $.ajax({
                url: 'http://in.xl9.xunlei.com/index.php/comment/add',
                dataType: 'jsonp',
                data: {
                    userid: common.getCookie('userid'),
                    peerid: api.getPeerID(),
                    usernick: common.getCookie('usernick'),
                    movieid: opts.movieid,
                    userlevel: 0,
                    comment: content
                },
                success: function (json) {
                    if (json.errno === 2) {
                        dialog.alert('由于发表不良信息，您已被禁言。');
                        return false;
                    } else if (json.errno === 0) {
                        VideoComments.showTips('ico_c_ok', '评论成功！', function () {
                            var height = opts.$container.height();
                            var $comments = $('[data-role="comments"]');
                            var comCounts = parseInt($comments.attr('count'), 10) + 1;
                              $comments.html('<span class="ico_comment"></span> ' + comCounts + '条评论')
                                .attr('count', comCounts);
                            opts.$container.css('min-height', height)
                                .empty();
                            VideoComments.render();
                            VideoComments.toCommenAnchor();
                            $area.val(defaultText);
                            typeof opts.comCallback == 'function' && opts.comCallback();
                        });
                    }
                },
                error: function (res, err) {
                    VideoComments.showTips('ico_c_fail', '评论失败！');
                    var content = $area.val();
                    var max = 300;
                    if (content == '' || content == null || content == defaultText) {
                        opts.$comBtn
                            .addClass('dis');
                    } else {
                        opts.$comBtn.filter('.dis')
                            .removeClass('dis');
                    }
                    if (content.length > max) {
                        content = content.substr(0, max);
                        $area.val(content);
                    }
                },
                complete: function () {
                    $comBtn.addClass('dis');
                    $comBtn.attr('disable', null);
                    common.login_from_comments = false;
                }
            });
        },

        praiseHandler: function ($target, movieid) {
            if (common.getXl9Data('is_loging') == 1) {
                return false;
            }

            if (!common.clientLogined()) {
                api.showLoginDlg('moviedetail_like');
                return false;
            }

            if (common.webLoginStatusMissing()) {
                common.events.trigger('userLogin');
                return false;
            }

            if ($target.attr('disable') == 'disable') {
                return false;
            }

            var count = $target.attr('count');
            $target.attr('disable', 'disable');
            $.ajax({
                url: 'http://in.xl9.xunlei.com/index.php/movie/prize',
                dataType: 'jsonp',
                data: {
                    movieid: movieid,
                    userid: common.getCookie('userid'),
                    peerid: api.getPeerID()
                },
                success: function (json) {
                    if (json.errno == 0) {
                        $target.attr('count', ++count)
                            .html('<span class="ico_praises"></span>已赞(' + count + ')');
                    } else if (json.errno == 1) {
                        $target.attr('count', --count)
                            .html('<span class="ico_praises"></span>赞(' + count + ')');
                    }
                },
                error: function (res, err) { },
                complete: function () {
                    $target.attr('disable', null);
                    common.login_from_praise = false;
                }
            });
            return false;
        },

        showTips: function (style, msg, callback) {
            var $cont = $('.com_tips');
            $cont.html('<span class="' + style + '"></span>' + msg);
            $cont.fadeIn(300);
            var t = setTimeout(function () {
                $cont.fadeOut(300);
                typeof callback == 'function' && callback();
                clearTimeout(t);
            }, 2000);
        },

        toCommenAnchor: function (dura) {
            var _dura = dura || 100;
            $("html, body").animate({
                scrollTop: $("#anchor_com").offset().top
            }, _dura);
        }
    };

    if (typeof exports === 'object') {
        module.exports = VideoComments;
    }
})(jQuery, _);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/video_comments_old.js
// module id = 66
// module chunks = 10